let preLowResMask;

export const initOnnx = async () => {
    if (!window.onnxSession) {
        console.log('init init', Date.now());
        window.onnxSession = await ort.InferenceSession.create('https://live-cecom-image.bj.bcebos.com/ambience_icon/2023-9/1695130047304/b013f57cd335.onnx');
        console.log('init done', Date.now());
    }
};

function getTensorShape(array) {
    let shape = [1];
    let currentArray = array;
    while (currentArray.length > 0) {
        shape.push(currentArray.length);
        currentArray = currentArray[0];
    }
    return shape;
}

function getPreprocessShape(oldh, oldw, long_side_length) {
    const scale = long_side_length / Math.max(oldh, oldw);
    const neww = oldw * scale;
    const newh = oldh * scale;
    const newwRounded = Math.round(neww + 0.5);
    const newhRounded = Math.round(newh + 0.5);
    return [newhRounded, newwRounded];
}

function applyCoords(coords, original_size) {
    let oldH = original_size[0];
    let oldW = original_size[1];
    let newH;
    let newW;

    [newH, newW] = getPreprocessShape(oldH, oldW, 1024);

    // Deep copy coords
    const newCoords = coords.slice();

    for (let i = 0; i < coords.length; i++) {
        newCoords[i][0] = coords[i][0] * (newW / oldW);
        newCoords[i][1] = coords[i][1] * (newH / oldH);
    }

    return coords;
}

export const clip = async (embeddings, coords, imgObj) => {
    try {
        if (!window.onnxSession) {
            window.onnxSession = await ort.InferenceSession.create('https://live-cecom-image.cdn.bcebos.com/ambience_icon/2023-9/1695130047304/b013f57cd335.onnx');
        }

        const round1 = coords.length === 1;

        // 第一轮，preLowResMask重置
        if (round1) {
            preLowResMask = '';
        }

        const applyedCoords = applyCoords(coords, [imgObj.height, imgObj.width]);
        const calCoords = [...applyedCoords, [0.0, 0.0]];
        const calLables = [...new Array(coords.length).fill(1), -1.0];

        const feeds = {
            image_embeddings: embeddings,
            // image_embeddings: new ort.Tensor('float32', embeddings.flat(Infinity), [1, 256, 64, 64]), // 每次不变
            point_coords: new ort.Tensor('float32', calCoords.flat(Infinity), getTensorShape(calCoords)), // shape每次要变
            point_labels: new ort.Tensor('float32', calLables.flat(Infinity), getTensorShape(calLables)), // shape每次要变
            // eslint-disable-next-line
            mask_input: round1 ? new ort.Tensor('float32', new Float32Array(256 * 256), [1, 1, 256, 256]) : preLowResMask, // 第二轮开始用上一轮的low_res_masks
            has_mask_input: new ort.Tensor('float32', Float32Array.from([round1 ? 1 : 0]), [1]), // 第二轮开始用1填充
            orig_im_size: new ort.Tensor('float32', Float32Array.from([imgObj.height, imgObj.width]), [2]) // H,W 不用变
        };

        // feed inputs and run
        const results = await window.onnxSession.run(feeds);
        const {low_res_masks, masks} = results;
        masks.data = masks.data.map(x => (x > 0.1 ? 1 : 0));

        preLowResMask = low_res_masks;
        const newArray = toMultiDimensionalArray(masks.data, imgObj.height, imgObj.width);

        return newArray;
    }
    catch (e) {
        console.log('clip err', e);
    }
};

function toMultiDimensionalArray(array, rows, cols) {
    const result = [];

    for (let i = 0; i < rows; i++) {
        const start = i * cols;
        const end = start + cols;

        const subArray = array.slice(start, end);
        result.push(subArray);
    }

    return result;
}

// js正则修改图片名称，不更改图片后缀
export function renameImg(imageUrl, style) {
    if (!imageUrl || !style) {
        return imageUrl;
    }
    let match = imageUrl.match(/\/([^\/]+)\.([^.]+)$/);
    let oldName = match ? match[1] : '';
    let oldSuffix = match ? match[2] : '';

    return `${oldName}${style}.${oldSuffix}`;
}